module.exports = __webpack_public_path__ + "img/contactus_hover_cn@2x.6fd8a38c.png";